export default __webpack_public_path__ + "static/media/phone_inactive.5b2c6aeb.png";